import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
var ProfilePictureService = /** @class */ (function () {
    function ProfilePictureService() {
        this.picture = new Subject();
        this.changeEvent = this.picture.asObservable();
    }
    ProfilePictureService.prototype.changePicture = function () {
        this.picture.next();
    };
    ProfilePictureService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ProfilePictureService_Factory() { return new ProfilePictureService(); }, token: ProfilePictureService, providedIn: "root" });
    return ProfilePictureService;
}());
export { ProfilePictureService };
